import './calculation-summary-panel.scss'

import {
  useId,
} from 'react'
import {
  useTranslation,
} from 'react-i18next'
import {
  Card,
  IconButton,
  Tooltip,
} from '@mui/material'
import {
  ReceiptLong,
} from '@vedmarket/ui-kit'

import ApplicationCalculationSummary from './application-calculation-summary'

const ApplicationCalculationSummaryPanel = ({
  calculationNumber,
  tnvedReviews,
  tnvedChangesConfirmed,
  calculationComparison,
  calculationSnapshotProductCodes,
  hasProposalAdjustment,
  calculationCurrencyCode,
  managerView = false,
  isCollapsed = true,
  onToggle,
}: ApplicationCalculationSummaryPanelProps) => {
  const { t } = useTranslation()
  const contentId = useId()

  if (!calculationNumber) {
    return null
  }

  const summary = (
    <ApplicationCalculationSummary
      orderId={calculationNumber}
      tnvedReviews={tnvedReviews}
      tnvedChangesConfirmed={tnvedChangesConfirmed}
      calculationComparison={calculationComparison}
      calculationSnapshotProductCodes={calculationSnapshotProductCodes}
      hasProposalAdjustment={hasProposalAdjustment}
      calculationCurrencyCode={calculationCurrencyCode}
      onCollapse={managerView ? onToggle : undefined}
    />
  )

  if (!managerView) {
    return (
      <aside className='application-calculation-right-panel rightPanel' aria-label={t('applications__text__calculation')}>
        {summary}
      </aside>
    )
  }

  const showLabel = t('common__text__showCalculation')

  return (
    <aside
      className={`application-calculation-right-panel application-calculation-right-panel_collapsible${isCollapsed ? ' application-calculation-right-panel_collapsed' : ''} rightPanel`}
      aria-label={t('applications__text__calculation')}
    >
      <Card
        className='application-calculation-right-panel__card'
        sx={{
          boxShadow: 'none',
        }}
        id={contentId}
        aria-hidden={isCollapsed}
        ref={(element) => {
          element?.toggleAttribute('inert', isCollapsed)
        }}
      >
        {summary}
      </Card>
      <Card
        className='application-calculation-right-panel__collapsed-card'
        sx={{
          boxShadow: 'none',
        }}
        aria-hidden={!isCollapsed}
        ref={(element) => {
          element?.toggleAttribute('inert', !isCollapsed)
        }}
      >
        <Tooltip title={showLabel}>
          <IconButton
            aria-label={showLabel}
            aria-expanded={!isCollapsed}
            aria-controls={contentId}
            onClick={onToggle}
            sx={{
              width: '48px',
              height: '48px',
              padding: '12px',
              borderRadius: '50%',
            }}
          >
            <ReceiptLong width={24} height={24} aria-hidden />
          </IconButton>
        </Tooltip>
      </Card>
    </aside>
  )
}

export default ApplicationCalculationSummaryPanel
